import React from 'react';
import { CheckCircle2Icon, ClockIcon, CreditCardIcon, LockIcon, ShieldCheckIcon, SmartphoneIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { mockupImage } from '../data/megaPack';
const trustItems = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: CreditCardIcon,
  label: 'Pago seguro'
}, {
  icon: CheckCircle2Icon,
  label: 'Mercado Pago'
}, {
  icon: ClockIcon,
  label: 'Acceso inmediato'
}];
export function Hero() {
  return <header className="relative overflow-hidden bg-teal-900 text-cream-50" data-id="element-144" data-mp="x9un9d91ji43">
      <div className="pointer-events-none absolute inset-0 opacity-[0.07]" aria-hidden="true" style={{
      backgroundImage: 'radial-gradient(circle at 1px 1px, #fbf7ef 1px, transparent 0)',
      backgroundSize: '28px 28px'
    }} data-id="element-145" data-mp="sbb1bcug66bq" />

      <div className="relative bg-gold-500 py-2 text-teal-900" data-id="element-146" data-mp="3cz5x6h3fwa2z">
        <p className="flex items-center justify-center gap-2 text-center font-display text-[0.7rem] font-800 uppercase tracking-[0.16em] sm:text-sm sm:tracking-[0.2em]" data-id="element-147" data-mp="380vznzu8sxe7">
          <LockIcon className="h-3.5 w-3.5 shrink-0 sm:h-4 sm:w-4" aria-hidden="true" data-id="element-148" data-mp="3o7vl7nivvtyv" />
          Compra 100% segura
        </p>
      </div>

      <div className="relative mx-auto max-w-3xl px-5 pb-10 pt-6 text-center sm:px-8 sm:pb-16 sm:pt-10 lg:pb-20 lg:pt-12" data-id="element-149" data-mp="39a32ynlycrgz">
        {/* Título / promesa de la landing */}
        <h1 className="font-display text-[2rem] font-900 uppercase leading-[0.95] tracking-tight sm:text-5xl lg:text-6xl" data-id="element-150" data-mp="30h9blrt8e1mr">
          Mega Pack
          <span className="block text-gold-400 sm:mt-1" data-id="element-151" data-mp="35akni7cwh8lj">Acompañante</span>
        </h1>

        <div className="mt-3 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 sm:mt-5" data-id="element-152" data-mp="2qhqurk8mavyx">
          <p className="inline-flex items-center rounded-full bg-gold-500/15 px-3 py-1 font-display text-xs font-800 uppercase tracking-[0.14em] text-gold-400 ring-1 ring-gold-400/30 sm:px-4 sm:py-1.5 sm:text-sm sm:tracking-[0.16em]" data-id="element-153" data-mp="2vgu0l6wf967y">
            7 tomos + 5 bonos
          </p>
          <p className="inline-flex items-center gap-1.5 text-xs font-600 text-cream-100/80 sm:text-sm" data-id="element-154" data-mp="s3mcu1g2bwxu">
            <StarIcon className="h-4 w-4 shrink-0 fill-gold-400 text-gold-400" aria-hidden="true" data-id="element-155" data-mp="na09izvsh5ep" />
            Más de 2.500 lectores
          </p>
        </div>

        {/* Mockup principal al 70%, entre la promesa y el subtítulo */}
        <img src={mockupImage} alt="Mega Pack Acompañante: el libro principal junto a los tomos, fichas de actividades y el planificador semanal en tablet y computadora." className="mx-auto mt-5 w-full max-w-xs rounded-2xl shadow-lift sm:mt-7 sm:max-w-md lg:max-w-xl" loading="eager" width={1260} height={1260} data-id="element-156" data-mp="1azumdhg3ytyy" />

        {/* Subtítulo del módulo inicial */}
        <p className="mx-auto mt-5 max-w-xl text-[0.9rem] leading-relaxed text-cream-100/85 sm:mt-7 sm:text-lg" data-id="element-157" data-mp="3lu9w2xv49s9n">
          Un sistema completo de actividades para mejorar la movilidad y acompañar a adultos mayores: juegos, estimulación cognitiva, movimiento, creatividad, conversación y propuestas para compartir.
        </p>

        <p className="mx-auto mt-3 max-w-xl font-display text-sm font-700 text-cream-50 sm:mt-4 sm:text-base" data-id="element-158" data-mp="269zivui4kzox">
          Sin pasar horas buscando actividades. Sin repetir siempre lo mismo.
        </p>

        <p className="mt-4 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-xs text-cream-100/70 sm:mt-6 sm:gap-x-3 sm:text-sm" data-id="element-159" data-mp="2fzss4ousp2q0">
          <SmartphoneIcon className="h-4 w-4 text-gold-400" aria-hidden="true" data-id="element-160" data-mp="2kxkkfjzcqquq" />
          <span data-id="element-161" data-mp="2p08u1tvw41sr">PDF Digital</span>
          <span aria-hidden="true" data-id="element-162" data-mp="2p10eq9ny8f49">·</span>
          <span data-id="element-163" data-mp="2tzbpcmm2itnj">Acceso inmediato</span>
          <span aria-hidden="true" data-id="element-164" data-mp="2tyadifx8a34r">·</span>
          <span data-id="element-165" data-mp="2tx7m86vztyob">Celular, tablet o computadora</span>
        </p>

        <div className="mt-6 sm:mt-8" data-id="element-166" data-mp="uo0t9zww0qp2">
          <CtaButton label="Quiero mi Mega Pack Acompañante" size="lg" target="offer" data-id="element-167" data-mp="zlkifuv4invs" />
        </div>

        <ul className="mx-auto mt-5 grid max-w-md grid-cols-2 gap-x-3 gap-y-2 sm:mt-7 sm:flex sm:max-w-none sm:flex-wrap sm:justify-center sm:gap-x-6" data-id="element-168" data-mp="4a2ulkgef9zm">
          {trustItems.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-1.5 text-xs text-cream-100/75 sm:gap-2 sm:text-sm" data-id="element-169" data-mp="e91t4a7g9p8w">
              <Icon className="h-3.5 w-3.5 shrink-0 text-gold-400 sm:h-4 sm:w-4" aria-hidden="true" data-id="element-170" data-mp="3hq0rzqfjvi7f" />
              {label}
            </li>)}
        </ul>
      </div>
    </header>;
}